import ApprovalProcess from './src/ApprovalProcess.vue';
import LookBpmn from './src/components/LookBpmn.vue';

export { ApprovalProcess, LookBpmn };
export default ApprovalProcess;
